var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-preview-circle d-flex justify-content-center align-items-center mx-auto"},[(_vm.urlImage)?_c('img',{attrs:{"src":_vm.urlImage,"alt":""}}):_c('i',{staticClass:"el-icon-picture-outline-round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }